var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuildTestDataSetNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 9.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4935 20.8973C25.4056 20.8973 27.801 20.4486 29.6797 19.5511C31.5585 18.6537 32.4978 17.6192 32.4978 16.4476C32.4978 15.2595 31.5585 14.2213 29.6797 13.3328C27.801 12.4443 25.4056 12 22.4935 12C19.5843 12 17.1925 12.4443 15.3181 13.3328C13.4437 14.2213 12.5065 15.2595 12.5065 16.4476C12.5065 17.6192 13.4437 18.6537 15.3181 19.5511C17.1925 20.4486 19.5843 20.8973 22.4935 20.8973ZM22.5 23.5589C23.4654 23.5589 24.5265 23.4744 25.6833 23.3054C26.84 23.1364 27.9249 22.8773 28.938 22.528C29.9511 22.1788 30.798 21.7355 31.4788 21.1981C32.1596 20.6606 32.5 20.0249 32.5 19.2909V22.1785C32.5 22.9154 32.1596 23.5526 31.4788 24.09C30.798 24.6275 29.9511 25.0701 28.938 25.4178C27.9249 25.7656 26.84 26.024 25.6833 26.193C24.5265 26.362 23.4654 26.4465 22.5 26.4465C21.5438 26.4465 20.485 26.362 19.3237 26.193C18.1623 26.024 17.0751 25.7626 16.062 25.4087C15.0489 25.0549 14.202 24.6093 13.5212 24.0718C12.8404 23.5344 12.5 22.9033 12.5 22.1785V19.2909C12.5 20.0157 12.8404 20.6461 13.5212 21.1821C14.202 21.7181 15.0489 22.163 16.062 22.5168C17.0751 22.8706 18.1623 23.1328 19.3237 23.3032C20.485 23.4737 21.5438 23.5589 22.5 23.5589ZM22.5 29.1081C23.4654 29.1081 24.5265 29.0235 25.6833 28.8545C26.84 28.6855 27.9249 28.4261 28.938 28.0761C29.9511 27.7262 30.798 27.2825 31.4788 26.7451C32.1596 26.2076 32.5 25.5704 32.5 24.8336V27.732C32.5 28.466 32.1596 29.1017 31.4788 29.6392C30.798 30.1766 29.9511 30.62 28.938 30.9692C27.9249 31.3184 26.84 31.5775 25.6833 31.7465C24.5265 31.9155 23.4654 32 22.5 32C21.5438 32 20.485 31.9148 19.3237 31.7443C18.1623 31.5739 17.0751 31.3117 16.062 30.9579C15.0489 30.6041 14.202 30.1592 13.5212 29.6232C12.8404 29.0872 12.5 28.4568 12.5 27.732V24.8336C12.5 25.5583 12.8404 26.1894 13.5212 26.7269C14.202 27.2643 15.0489 27.71 16.062 28.0638C17.0751 28.4176 18.1623 28.6801 19.3237 28.8513C20.485 29.0225 21.5438 29.1081 22.5 29.1081Z",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildTestDataSetNew);
export default __webpack_public_path__ + "static/media/iconBuildTestDataSetNew.a9922d9d.svg";
export { ForwardRef as ReactComponent };